import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"progress-bar\">\n  {{!-- template-lint-disable no-inline-styles --}}\n  <span class=\"meter\" style={{this.widthStyle}}>\n    <p>\n      {{or @percentage \"0\"}}%\n    </p>\n  </span>\n</div>\n", {
  moduleName: "ilios-common/components/progress-bar.hbs"
});